import { render, staticRenderFns } from "./ImageHorizontal.vue?vue&type=template&id=2a021458&scoped=true&lang=pug&"
import script from "./ImageHorizontal.vue?vue&type=script&lang=ts&"
export * from "./ImageHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageHorizontal.vue?vue&type=style&index=0&id=2a021458&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a021458",
  null
  
)

export default component.exports